// 主人公の通常攻撃 (連撃3段) を、描いたコマで出す。
//   2026-10-02 ユーザー: 骨 (Spine)・描いたコマ・3D を並べて「一番動きとしてよいのは書いたコマのやつだな」。
//   攻撃中だけここで描き、待機・歩き・パリィ・回避・被弾などは Spine のまま。見切りカウンターも Spine のまま。
//   10-02 夜から既定は骨 (Spine attack_1 / attack_2 / attack_3)。描いたコマは開発中だけ ?playerAttackArt=frames。
//   コマと配置は scripts/build_player_attack_frames.py が作る (player_attack_frames_data.ts)。
import { PLAYER } from './balance'
import { playerComboEnabled } from './player_combo_switch'
import { heavyLungeProgress, toFrameTimelineMs } from './player_attack_timing'
import { PLAYER_ATTACK_FRAMES, type PlayerAttackFrame } from './player_attack_frames_data'

const images = new Map<string, HTMLImageElement>()
let loadStarted = false

function framesEnabled(): boolean {
  // 2026-10-02 ユーザー「配布版はひとまず…Spineで1パターンの攻撃しかしていない状態に戻しておいて」= 連撃を切っている間は出さない。
  if (!playerComboEnabled()) return false
  // 10-02 夜: 骨 (Spine attack_1/2/3) を描いたコマの姿勢で作り直したので、既定は骨。
  //   描いたコマとの見比べは開発中だけ ?playerAttackArt=frames (配布コードに URL の切替を出さない = scripts/check_dev_leak.mjs)
  if (!import.meta.env.DEV || typeof location === 'undefined') return false
  return new URLSearchParams(location.search).get('playerAttackArt') === 'frames'
}

export function preloadPlayerAttackFrames(): void {
  if (loadStarted || typeof Image === 'undefined') return
  loadStarted = true
  for (const step of PLAYER_ATTACK_FRAMES) {
    for (const f of step) {
      const img = new Image()
      img.src = `/sprites/lunaire-frames/${f.name}.webp`
      images.set(f.name, img)
    }
  }
}

/** 段 (0〜2) と攻撃の経過 ms から出すコマ。最後のコマは時間を過ぎても保持する。 */
export function pickPlayerAttackFrame(step: number, elapsedMs: number): PlayerAttackFrame | null {
  const frames = PLAYER_ATTACK_FRAMES[step]
  if (!frames || frames.length === 0) return null
  return frames.find((f) => elapsedMs < f.untilMs) ?? frames[frames.length - 1]
}

/** 3段目の踏み込みでゲームが体を前へ出した量 (player.ts moveDuringHeavyLunge と同じ曲線)。 */
export function heavyLungeTravelPx(step: number, elapsedMs: number): number {
  if (step !== PLAYER.attackComboSteps - 1) return 0
  return PLAYER.attackHeavyLungePx * heavyLungeProgress(step, elapsedMs)
}

/**
 * 攻撃中のコマを描く。描けた時だけ true (画像が未読込・無効なら false = 呼び出し側が Spine で描く)。
 * ctx は足元 (体の位置) が原点・前向きが +x になっている前提 (render.ts renderPlayerInto)。
 */
export function drawPlayerAttackFrame(ctx: CanvasRenderingContext2D, step: number, elapsedMs: number): boolean {
  if (!framesEnabled()) return false
  preloadPlayerAttackFrames()
  // コマは旧の時間割 (C) で作ってあるので、選んでいる速さの時間割から写して選ぶ。
  const f = pickPlayerAttackFrame(step, toFrameTimelineMs(step, elapsedMs))
  if (!f) return false
  const img = images.get(f.name)
  if (!img || !img.complete || img.naturalWidth === 0) return false
  // 3段目: ゲームは体の位置を前へ出しているので、その分だけ戻して描く (足を床に留める)
  const back = heavyLungeTravelPx(step, elapsedMs)
  ctx.drawImage(img, f.dx - back, f.dy, f.w, f.h)
  return true
}
